import { Injectable } from '@angular/core';
import {
  CountriesService as ArgosCountryService,
  Country
} from '@core-argos-angular-artifact/common';
import { ConfigService } from '@core-argos-angular-artifact/core';
import { Observable } from 'rxjs';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class ApiCountryService {
  private readonly urlBase: string;

  constructor(
    private readonly countryService: ArgosCountryService,
    private readonly langService: LanguageService,
    private readonly configService: ConfigService
  ) {
    const config = this.configService.getConfig();
    this.urlBase = `${config.apiCountrySvc}/api/country`;
  }

  getCountries(): Observable<Country[]> {
    return this.countryService.getCountries(this.urlBase, {
      'Accept-Language': this.langService.getLang().replace(/_/g, '-')
    });
  }

  getCountry(countryCode: string): Observable<Country> {
    const country = countryCode?.toUpperCase() || '';
    return this.countryService.getCountry(
      this.urlBase,
      {
        'Accept-Language': this.langService.getLang().replace(/_/g, '-')
      },
      country
    );
  }
}
